import { Routes } from "@angular/router";

export const PREFAB_CONFIGURATION_CHILD_ROUTES: Routes = [
  {
    path: 'resources',
    loadComponent: () => import('./resources/resources.component').then(c => c.ResourcesComponent)
  },
  {
    path: 'properties',
    loadComponent: () => import('./properties/properties.component').then(c => c.PropertiesComponent)
  },
  {
    path: 'events',
    loadComponent: () => import('./events/events.component').then(c => c.EventsComponent)
  },
  {
    path: 'methods',
    loadComponent: () => import('./methods/methods.component').then(c => c.MethodsComponent)
  },
  {
    path: 'packaging',
    loadComponent: () => import('./packaging/packaging.component').then(c => c.PackagingComponent)
  },
  {
    path: "appenv",
    loadComponent: () => import('./app-environment/app-environment.component').then(c => c.AppEnvironmentComponent)
  }
]
